// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];



//////////////////
// WEBPACK FOOTER
// ./~/react-stickynode/~/core-js/internals/enum-bug-keys.js
// module id = 248
// module chunks = 0